export const SUBJECT_PLACEHOLDER = 'Subject';
export const SHARE_YOUR_FEEDBACK_OR_REQUEST_PLACEHOLDER =
  'Share your feedback or request';
export const SHARE_FEEDBACK_BTN = 'Share feedback';
